import { withCurrentRoute } from '../../components/HOCComponents/withCurrentRoute'

import TopBar from '../../components/TopBar'

export default withCurrentRoute(TopBar)
